import clsx from 'clsx';
import React from 'react';

import IconTriangle from '@components/Images/Rebranding/IconTriangle';
import LazyImgixImage from '@components/LazyImgixImage';

import SubscribeButtonBlock from '../SubscribeButtonBlock';
import type { HeroBlockProps } from '../interfaces';

const HeroBlock = ({ config, content, offer }: HeroBlockProps) => {
  const { alt, headline, intro, slash_variant, src } = content;
  const {
    display_price_breakdown: showPriceBreakdown,
    is_dark_mode: isDarkMode,
    show_subscribe_button: showSubscribeButton,
  } = config;

  console.log('config', config);
  console.log('content', content);

  return (
    <article
      className={clsx(
        'hero-block relative -ml-16 -mt-56 w-[100svw] px-16 pt-56 sm:-ml-28 sm:-mt-64 sm:px-28 xl:ml-[calc((100svw-1256px)/-2)]',
        config?.css_classes,
        {
          'bg-grayscale-charcoal text-white': isDarkMode,
          'bg-white text-grayscale-charcoal': !isDarkMode,
        }
      )}
    >
      <div className="relative w-full md:flex md:flex-row md:flex-nowrap md:items-start xl:mx-auto xl:max-w-container-lg">
        <header className="mx-auto flex max-w-[560px] flex-col items-center justify-center text-center md:mx-0 md:mt-16 md:items-start md:justify-start md:text-left lg:mt-48">
          <h1
            className={clsx(
              'm-0 font-suisse-works text-headline-sm font-medium sm:text-headline-lg md:text-headline-xl',
              {
                'text-white': isDarkMode,
              }
            )}
          >
            {headline}
          </h1>
          <p className="m-0 mt-8 font-suisse-neue text-body-md font-normal sm:text-subheadline-sm">
            {intro}
          </p>
          {showSubscribeButton && (
            <div className="mt-16">
              <SubscribeButtonBlock
                config={{
                  display_subscription_description: false,
                  display_price_breakdown: showPriceBreakdown,
                  is_dark_mode: isDarkMode,
                  pro_subscription: true,
                  subscribe_one: true,
                  text: 'Subscribe today',
                }}
                offer={offer}
              />
            </div>
          )}
        </header>
        {src && (
          <figure className="relative z-10 mx-auto mt-32 w-[61%] max-w-[265px] md:my-0 lg:max-w-[350px]">
            <LazyImgixImage
              alt={alt}
              className="block h-auto w-full object-cover"
              src={src}
              visibleByDefault
            />
          </figure>
        )}
      </div>
      <IconTriangle
        className={clsx('absolute bottom-[-1px] right-0 h-auto w-full sm:w-[86%] md:max-w-[47%]', {
          'text-primary-magenta': slash_variant === 'magenta',
          'text-pro-gold': slash_variant === 'pro',
        })}
      />
    </article>
  );
};

export default HeroBlock;
